import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { HttpClient } from '@angular/common/http';
import { Globals } from '../../../globals';
import { AdsServices } from '../services';

/**
 * Generated class for the DishViewAllergensPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-provider-file',
    templateUrl: 'provider-file.html',
})
export class ProviderFilePage {

    private provider: any;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public http: HttpClient,
        public globals: Globals,
        public adsServices: AdsServices) {

        this.provider = this.navParams.get('provider');

        //Ads tracking de provider file
        this.adsTracking();

        
        this.getElements();
    }

    async adsTracking(){
        //IMPORTANTE AWAIT PARA HACER LOS DOS PASOS POR SEPARADO

        
        //Track cuando entramos en la ficha del proveedor
        await this.adsServices.trackFunction("Display", this.adsServices.actual_page, null, null, this.provider.name, this.provider.UID, 0, 0, 1, "display_provider_page");
        //Track cuando vamos a la ficha del proveedor
        await this.adsServices.trackFunction("Click", this.adsServices.actual_page, null, null, this.provider.name, this.provider.UID, 1, 0, 0, "click_provider_display_page");
    }

    async getElements() {
        this.adsServices.actual_page = 'Provider File';
        //Recuperamos el proveedor
        await this.adsServices.getProviderFile(this.provider);
    }

    addProvider(provider) {
        //Añadimos el proveidor
        this.adsServices.addProviderAndRefs(provider);
    }

    contactProvider(provider) {
        //Enviamos la info del proveidor para poder mandar un email
        this.adsServices.contactProvider(provider);
    }

    addElement(element, type) {
        this.adsServices.addElement(element, type);
    }
}


// WEBPACK FOOTER //
// ./src/pages/ads/provider-file/provider-file.ts